import type { SVGProps } from "react";
export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 25"
    className="fill-current"
    {...props}
  >
    <path
      fill="#EBEBEB"
      d="m19.6 21.083-6.3-6.3q-.75.6-1.725.95t-2.075.35q-2.725 0-4.612-1.888T3 9.583t1.888-4.612Q6.778 3.084 9.5 3.083t4.613 1.888Q16.003 6.86 16 9.583a6.1 6.1 0 0 1-1.3 3.8l6.3 6.3zm-10.1-7q1.875 0 3.188-1.312Q14.001 11.46 14 9.583q0-1.876-1.312-3.187-1.311-1.31-3.188-1.313-1.877-.001-3.187 1.313Q5.003 7.712 5 9.583t1.313 3.188T9.5 14.083"
    />
  </svg>
);
